import React, { useState, useEffect } from 'react'
import ReviewCard from './ReviewCard'
import '../styles/home.css'
import axios from 'axios';
import { reviews } from './data';


function Review() {


    // const [reviews, setReviews] = useState([]);
    const [cardsToShow, setCardsToShow] = useState(getInitialCardsToShow()); // Initialize based on screen size
    const [startIndex, setStartIndex] = useState(0);

    // const API = process.env.REACT_APP_API_URL;


    function getInitialCardsToShow() {
        if (window.innerWidth >= 992) {
            return 3;
        } else if (window.innerWidth >= 768) {
            return 2;
        } else {
            return 1;
        }
    }


    // useEffect(() => {
    //     const fetchReviews = async () => {
    //         try {
    //             const { data } = await axios.get(`${API}/api/reviews`);
    //             setReviews(data);
    //         } catch (err) {
    //             console.error('Error fetching reviews:', err);
    //         }
    //     };
    //     fetchReviews();
    // }, [API]);

    // Adjust cardsToShow on screen resize
    useEffect(() => {
        const updateCardsToShow = () => {
            const newCardsToShow = getInitialCardsToShow();

            setCardsToShow((prevCardsToShow) => {
                // Update startIndex if cardsToShow changes
                if (prevCardsToShow !== newCardsToShow) {
                    setStartIndex((prevStartIndex) =>
                        Math.min(prevStartIndex, Math.max(reviews.length - newCardsToShow, 0))
                    );
                }
                return newCardsToShow;
            });
        };

        window.addEventListener('resize', updateCardsToShow);

        return () => {
            window.removeEventListener('resize', updateCardsToShow);
        };
    }, [reviews.length]);

    // Navigation handlers
    const handlePrev = () => {
        setStartIndex((prevIndex) => Math.max(prevIndex - cardsToShow, 0));
    };

    const handleNext = () => {
        setStartIndex((prevIndex) =>
            Math.min(prevIndex + cardsToShow, reviews.length - cardsToShow)
        );
    };

    const visibleReviews = reviews.slice(startIndex, startIndex + cardsToShow);


    return (
        <div id="carousel">
            <div id="review-carousel-top">
                <h2 id='review-from-clients'>REVIEWS FROM CLIENTS</h2>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <div className="rvw-btn" onClick={handlePrev}>
                        <svg className="rvw-btn-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.48 79.09">
                            <path className="rvw-btn-arrow-fill"
                                d="M207.91,103.42l-22.15,25,22.15,25,3.48,3.93a6.36,6.36,0,0,1,1.61,4.23h0a6.39,6.39,0,0,1-11.16,4.24l-11-12.4L173.62,134a8.36,8.36,0,0,1,0-11.08l17.23-19.45,11-12.4A6.39,6.39,0,0,1,213,95.26h0a6.36,6.36,0,0,1-1.61,4.23Z"
                                transform="translate(-171.52 -88.86)" />
                        </svg>
                    </div>
                    <div className="rvw-btn" onClick={handleNext}>
                        <svg className="rvw-btn-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.48 79.09">
                            <path className="rvw-btn-arrow-fill"
                                d="M176.61,103.42l22.15,25-22.15,25-3.48,3.93a6.36,6.36,0,0,0-1.61,4.23h0a6.39,6.39,0,0,0,11.16,4.24l11-12.4L210.9,134a8.36,8.36,0,0,0,0-11.08l-17.23-19.45-11-12.4a6.39,6.39,0,0,0-11.16,4.24h0a6.36,6.36,0,0,0,1.61,4.23Z"
                                transform="translate(-171.52 -88.86)" />
                        </svg>
                    </div>

                </div>

            </div>

            <div id="carousel-main">

                {visibleReviews.map((review) => {
                    return <ReviewCard key={review.id} description={review.description} customerName={review.customerName} />
                })}




            </div>



        </div>
    )
}

export default Review